<template>
  <vx-card class="vx-card_full-height">
    <div class="flex flex-col flex-1">
      <div :class="$style.header">
        <div :class="$style.back">
          <vs-button type="border" @click="$router.go(-1)" iconPack="feather" icon="icon-arrow-left">Назад</vs-button>
        </div>

        <h4 class="whitespace-no-wrap">Группы помещений</h4>
        <div :class="$style.aside">
          <vs-button @click="onCreate" iconPack="feather" icon="icon-plus" type="border">
            Добавить группу
          </vs-button>
        </div>
      </div>
      <div v-if="apartmentsGroups">
        <template v-if="apartmentsGroups.length">
          <apartments-group
            v-for="apartmentsGroup in apartmentsGroups"
            :key="apartmentsGroup.id"
            :apartments-group="apartmentsGroup"
            @update="loadData()"
          />
        </template>
        <div v-else :class="$style.empty">Групп помещений нет. Нажмите на кнопку «+&nbsp;Добавить&nbsp;группу».</div>
      </div>
      <div v-else class="block-loading" />
    </div>
  </vx-card>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";
import ApartmentsGroup from "@/components/employee/apartments-groups/ApartmentsGroup";

export default {
  name:       "ApartmentsGroups",
  components: { ApartmentsGroup },
  mixins:     [notifyHttpError],
  data() {
    return {
      apartmentsGroups: null,
    };
  },
  computed:   {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:    {
    loadData() {
      this.$http.get(`houses/${this.selectedHouseId}/apartments_groups`)
        .then(( { data } ) => this.apartmentsGroups = data);
    },

    onCreate() {
      const buildingId = this.selectedHouseId;
      this.$modal.open({
        size:           'lg',
        title:          'Добавить группу помещений',
        component:      () => import('@/components/employee/apartments-groups/ApartmentsGroupsFormPopup'),
        componentProps: {
          buttonText: 'Создать',
          buildingId,
          onSubmit:   ( data ) => {
            return this.$http.post(`apartments_groups`, {
              building_id:    buildingId,
              number:         data.title,
              apartments_ids: data.apartments,
            }).then(() => this.loadData());
          },
        },
      });
    },
  },
  mounted() {
    this.loadData();
  },
  watch:      {
    selectedHouseId() {
      this.loadData();
    },
  },
};
</script>

<style lang="scss" module>
.back {
  margin-right: 2em;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
}

.aside {
  margin-left: auto;
}

.empty {
  text-align: center;
  font-size: 2.5em;
  font-style: italic;
  font-weight: 300;
  opacity: .3;
  border-top: 1px solid #000;
  margin-top: 1em;
  padding-top: 1em;
}
</style>
